import React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import cn from './cn';

/**
 * A rule. Replaces 16 MUI `Divider`s and the hand-written `<hr>`s.
 *
 * Radix rather than a bare `<hr>` because it sets `role="separator"` and
 * `aria-orientation` correctly, and takes `decorative` for the common case where the rule
 * is a visual flourish and should be hidden from assistive technology.
 */
const Separator = React.forwardRef(
  ({ className, orientation = 'horizontal', decorative = true, ...props }, ref) => (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'tw-shrink-0 tw-bg-line-light tw-border-0',
        orientation === 'horizontal' ? 'tw-h-px tw-w-full' : 'tw-w-px tw-h-full',
        className
      )}
      {...props}
    />
  )
);
Separator.displayName = 'Separator';

export default Separator;
